export default () => ({
  show: false,
  isLoading: true,
  onCancel: false,
  fullPage: true,
  files: [],
  years: {},
  entity: 'file',
  entities: 'files',
  prefixRouter: 'dweller.file'
})



// WEBPACK FOOTER //
// ./src/app/dweller/files/resources/data.js